import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import Card from 'react-bootstrap/Card';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { Trans } from 'react-i18next';
import ProductLayer from '../ProductLayer';
import heap from '../../containers/App/heap';
import usePrevious from '../../hooks/usePrevious';
import i18next from '../../translations/i18n';
import AppTypeContext from '../../contexts/AppTypeContext';
import API from '../../services/API';
import './index.scss';

const fontSizeFromnColumns = (nColumns, toSubtract) => {
  if (nColumns <= 3) {
    return `${toSubtract ? 14 - toSubtract : 14}px`;
  }
  if (nColumns <= 5) {
    return `${toSubtract ? 14 - toSubtract : 14}px`;
  }
  return `${toSubtract ? 14 - toSubtract : 14}px`;
};

const UnderlyingBox = ({ underlying }) => {
  const appName = useContext(AppTypeContext);
  const prevCount = usePrevious(underlying.chg);
  const [openLayer, setOpenLayer] = useState(false);
  const [className, setClassName] = useState('');
  const [bg, setBg] = useState(
    `rgba(${[
      underlying.color.r,
      underlying.color.g,
      underlying.color.b,
      underlying.color.a,
    ].join(',')})`,
  );

  useEffect(() => {
    if (prevCount !== underlying.chg) {
      setClassName('blink');
      setBg(
        `rgba(${[
          underlying.color.r,
          underlying.color.g,
          underlying.color.b,
          underlying.color.a,
        ].join(',')})`,
      );
    }
    setTimeout(() => {
      setClassName('');
    }, 1000);
  }, [underlying]);

  return (
    <React.Fragment key={underlying.name}>
      <Card
        onMouseEnter={() => {
          setBg(
            `rgba(${[
              underlying.color.r,
              underlying.color.g,
              underlying.color.b,
              0.7,
            ].join(',')})`,
          );
        }}
        onMouseLeave={() => {
          setBg(
            `rgba(${[
              underlying.color.r,
              underlying.color.g,
              underlying.color.b,
              underlying.color.a,
            ].join(',')})`,
          );
        }}
        size="lg"
        style={{
          height: '90px',
          background: bg,
          color: 'black',
          transition: 'all 0.2s ease',
        }}
        className={`underlying rounded-1 ${className}`}
      >
        <OverlayTrigger
          key="top"
          placement="top"
          delay={{ show: 250, hide: 400 }}
          overlay={
            <Tooltip style={{ fontSize: fontSizeFromnColumns(6, -2) }}>
              {i18next.t('clickToView')} <Trans>{underlying.name}</Trans>
            </Tooltip>
          }
        >
          <Card.Body
            className="py-3 px-4 shadow underlying-txt"
            name={underlying.name}
            type={appName}
          >
            <Card.Text
              className="m-0 underlying-txt"
              style={{
                fontSize: fontSizeFromnColumns(6, -2),
                lineHeight: '16px',
              }}
            >
              <Trans>{underlying.name}</Trans>
            </Card.Text>
            <Card.Text
              as="div"
              className=""
              style={{
                fontSize: fontSizeFromnColumns(6, -2),
                fontWeight: '600',
                lineHeight: '16px',
                position: 'absolute',
                bottom: '8px',
              }}
            >
              <Trans>{`${underlying.chg}`}%</Trans>
            </Card.Text>
            <Card.Link
              className="mt-auto stretched-link"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                API.sendToGA(`${appName}-open-${underlying.name}`);
                heap.track('ClickUnderlying', { name: underlying.name });
                setOpenLayer(true);
              }}
            />
          </Card.Body>
        </OverlayTrigger>
      </Card>
      {openLayer && (
        <ProductLayer
          product={underlying}
          show={openLayer}
          onHide={() => setOpenLayer(false)}
          onEscapeKeyDown={(e) => {
            e.preventDefault();
            setOpenLayer(false);
          }}
        />
      )}
    </React.Fragment>
  );
};
UnderlyingBox.propTypes = {
  underlying: PropTypes.shape({
    name: PropTypes.string.isRequired,
    chg: PropTypes.string.isRequired,
    color: PropTypes.shape({
      r: PropTypes.number.isRequired,
      g: PropTypes.number.isRequired,
      b: PropTypes.number.isRequired,
      a: PropTypes.number.isRequired,
    }),
  }).isRequired,
};

export default UnderlyingBox;
